import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { HttpService } from 'src/app/services/http.service';
import { URLUtils } from 'src/app/urlUtils';
import {
  buildLoginDevicePayload,
  DeviceSyncLoginPayload,
  getOrCreateDeviceId
} from 'src/app/device.utils';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-registerotp',
    templateUrl: './registerotp.component.html',
    styleUrls: ['./registerotp.component.scss'],
    standalone: false
})
export class RegisterotpComponent implements OnInit, OnDestroy {
  
  // OTP Registration form
  otpForm: any = FormGroup;
  otpSubmitted: boolean = false;
  otpSent: boolean = false;
  otpRequestInProgress: boolean = false;
  resendDisabled: boolean = false;
  resendTimer: number = 60;
  resendInterval: any;
  otpDigits: string[] = ['', '', '', '', '', ''];
  msg: string = "";
  msgError: boolean = false; 
  product = environment.product;
  showConfirmDialog: boolean = false;
  confirmDisplayEmail: string = '';
  confirmDisplayPhone: string = '';
  loginIdentifier: { type: 'email' | 'mobile'; value: string } | null = null;
  city:any;
  
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private httpservice: HttpService, private toast: ToastrService
  ) { }

  ngOnInit() {
    // OTP registration form
    this.otpForm = this.formBuilder.group({
      fullname: ['', [Validators.required]],
      email: ['', [Validators.required, this.emailValidator]],
      phone: ['', [Validators.required, this.phoneValidator]],
      identifier: [''],
      otp: ['', [Validators.pattern(/^[0-9]{6}$/)]],
      plan: [this.product]
    });

     this.httpservice.getCity().subscribe(res => {
      this.city = res.city
      console.log(res.city);
      
    });

    // If we arrived here from the login screen after a "user not found"
    // response, carry the email/mobile over and pre-fill it here.
    const queryParams = this.route.snapshot.queryParams;
    if (queryParams['email']) {
      this.otpForm.patchValue({ email: queryParams['email'] });
    } else if (queryParams['mobile']) {
      this.otpForm.patchValue({ phone: queryParams['mobile'] });
    }
  }

  ngOnDestroy() {
    // Clean up interval on component destroy
    if (this.resendInterval) {
      clearInterval(this.resendInterval);
    }
  }

  get otpF() { return this.otpForm.controls; }

  onPhoneInput(event: any) {
    // Strip leading zeros as user types
    const input = event.target;
    const stripped = input.value.replace(/^0+/, '').replace(/\D/g, '');
    if (input.value !== stripped) {
      input.value = stripped;
      this.otpForm.get('phone').setValue(stripped, { emitEvent: false });
    }
  }

  onlyLetters(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode === 32 || charCode === 46) {
      return true;
    }
    event.preventDefault();
    return false;
  }
  // onlyLetters(event: any) {

  //   const charCode = event.which ? event.which : event.keyCode;
  //   const inputValue = event.target.value;

  //   const isLetter =
  //     (charCode >= 65 && charCode <= 90) ||   // A-Z
  //     (charCode >= 97 && charCode <= 122);    // a-z

  //   const isSpace = charCode === 32;
  //   const isDot = charCode === 46;

  //   // Prevent space as first character
  //   if (isSpace && inputValue.length === 0) {
  //     event.preventDefault();
  //     return false;
  //   }

  //   if (isLetter || isSpace || isDot) {
  //     return true;
  //   }

  //   event.preventDefault();
  //   return false;
  // }

  emailValidator = (control: any) => {
    if (!control.value) return null;
    const value = control.value.trim();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(value) ? null : { invalidEmail: true };
  }

  phoneValidator = (control: any) => {
    if (!control.value) return null;
    // Strip leading zeros first
    const stripped = control.value.replace(/^0+/, '');
    const phoneRegex = /^[6-9][0-9]{9}$/;
    return phoneRegex.test(stripped) ? null : { invalidPhone: true };
  }

  emailOrMobileValidator(control: any) {
    if (!control.value) return null;

    const value = control.value.trim();

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const mobileRegex = /^[6-9][0-9]{9}$/; // Indian mobile format

    if (emailRegex.test(value) || mobileRegex.test(value)) {
      return null;
    }

    return { invalidIdentifier: true };
  }

  // OTP Box Navigation Methods
  onOtpKeyUp(event: any, index: number, nextInput: any) {
    const input = event.target;
    const value = input.value;

    // Allow only numbers
    if (value && !/^\d$/.test(value)) {
      this.otpDigits[index - 1] = '';
      return;
    }

    // Move to next input if value entered
    if (value && nextInput) {
      nextInput.focus();
    }

    // Handle backspace
    if (event.key === 'Backspace' && !value && index > 1) {
      const previousInput = event.target.previousElementSibling;
      if (previousInput) {
        previousInput.focus();
      }
    }

    // Update the form control with combined OTP
    this.updateOtpFormControl();
  }

  onOtpPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.replace(/\D/g, '').slice(0, 6).split('');
    
    this.otpDigits = [...digits, ...Array(6 - digits.length).fill('')];
    this.updateOtpFormControl();
  }

  updateOtpFormControl() {
    const otpValue = this.otpDigits.join('');
    this.otpForm.patchValue({ otp: otpValue });
  }

  cancelRegistration() {
    this.msg = "";
    this.msgError = false;
    this.otpSubmitted = false;
    this.otpSent = false;
    this.otpRequestInProgress = false;
    this.otpDigits = ['', '', '', '', '', ''];
    this.loginIdentifier = null;

    // Preserve fullname and identifier so fields are pre-filled after cancel
    // (consistent with Android back-navigation behaviour)
    const savedFullname = this.otpForm.getRawValue()['fullname'];
    const savedIdentifier = this.otpForm.getRawValue()['identifier'];
    const savedEmail = this.otpForm.getRawValue()['email'];
    const savedPhone = this.otpForm.getRawValue()['phone'];

    // Re-enable fields first (they were disabled when OTP was sent)
    this.otpForm.get('identifier').enable();
    this.otpForm.get('fullname').enable();
    this.otpForm.get('email').enable();
    this.otpForm.get('phone').enable();

    // Clear only OTP-related state, then restore the user's entered values
    this.otpForm.get('otp').reset();
    this.otpForm.get('otp').clearValidators();
    this.otpForm.get('otp').updateValueAndValidity();

    this.otpForm.patchValue({
      fullname: savedFullname || '',
      identifier: savedIdentifier || '',
      email: savedEmail || '',
      phone: savedPhone || '',
      plan: this.product
    });

    this.stopResendTimer();
  }

  onSubmit() {
    this.otpSubmitted = true;
    this.msg = "";
    console.log('onSubmit called, otpForm:', this.otpForm.value);

    // Normalize phone: strip leading zeros before validation runs
    const rawPhone = this.otpForm.get('phone').value || '';
    const normalizedPhone = rawPhone.replace(/^0+/, '').replace(/\D/g, '');
    if (rawPhone !== normalizedPhone) {
      this.otpForm.get('phone').setValue(normalizedPhone, { emitEvent: false });
    }

    // Validate required fields before sending OTP
    if (this.otpForm.get('fullname').invalid || this.otpForm.get('email').invalid || this.otpForm.get('phone').invalid) {
      return;
    }

    if (!this.otpSent) {
      // Show confirmation dialog — do NOT call API yet
      const rawPhone = this.otpForm.get('phone').value.replace(/^0+/, '');
      this.confirmDisplayEmail = this.otpForm.get('email').value.trim().toLowerCase();
      this.confirmDisplayPhone = rawPhone;
      this.showConfirmDialog = true;
    } else {
      // Verify OTP and complete registration
      if (this.otpForm.get('otp').invalid) {
        return;
      }
      this.verifyOTPAndRegister();
    }
  }

  /** User clicked "Yes, Continue" in the confirmation dialog */
  confirmAndProceed() {
    this.showConfirmDialog = false;
    // Populate identifier with phone (mobile) for the existing API logic
    const phone = this.confirmDisplayPhone;
    this.otpForm.get('identifier').setValue(phone);
    this.requestOTP();
  }

  /** User clicked "No, Edit" in the confirmation dialog */
  cancelConfirm() {
    this.showConfirmDialog = false;
  }

  // Get current date in DD/MM/YYYY format
  getCurrentDate(): string {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Request OTP from server
  requestOTP() {
    this.otpRequestInProgress = true;

    const identifier = this.otpForm.getRawValue()['identifier']?.trim();
    const fullname = this.otpForm.value['fullname'];
    const emailVal = this.otpForm.get('email').value.trim().toLowerCase();
    const phoneVal = this.otpForm.get('phone').value.replace(/^0+/, '');
    const isEmail = identifier.includes('@');

    const payload: any = {
      fullname: fullname,
      country: "India",
      contact_person: fullname,
      product: "lauditor",
      sub_model: "three_month_free",
      is_active_sub: true,
      accepted_terms: false,
      sub_start_date: this.getCurrentDate(),
      category: "solo",
      email: emailVal,
      phone: phoneVal,
      reg_city : this.city,
      reg_platform:"web"

    };

    // Add email or mobile based on identifier type
    if (isEmail) {
      payload.email = identifier.toLowerCase();
      localStorage.setItem('user_email', identifier.toLowerCase());
      localStorage.setItem('login_identifier_type', 'email');
    } else {
      payload.mobile = identifier;
      localStorage.setItem('user_mobile', identifier);
      localStorage.setItem('login_identifier_type', 'mobile');
    }

    this.httpservice.sendOtpPostRequest(URLUtils.registerRequestOTP, payload).subscribe(
      (resp: any) => {
        this.otpRequestInProgress = false;
        
        // If email already exists → Redirect to login
        // if (resp?.error === true && resp?.msg === "This email is already in use.") {
        //   this.msg = resp['msg'];
        //   this.msgError = resp['error'] === true; // Set based on resp.error
        //   const identifier = this.otpForm.getRawValue()['identifier']?.trim();
        //   // Store email/mobile so login page can auto-fill
        //   if (identifier.includes('@')) {
        //     localStorage.setItem('login_email', identifier.toLowerCase());
        //   } else {
        //     localStorage.setItem('login_mobile', identifier);
        //   }
        //   // wait before navigating
        //   setTimeout(() => {
        //     this.router.navigate(['/login']);
        //   }, 1000);  // Redirect to login
        //   return;
        // }

        // If email already exists → Open OTP screen and send OTP
        const isAlreadyInUse = resp?.error === true &&
          (resp?.msg === "This email is already in use." ||
           resp?.msg === "This mobile is already in use." ||
           (typeof resp?.msg === 'string' && resp.msg.toLowerCase().includes('already in use')) ||
           !!resp?.redirect_to);

        if (isAlreadyInUse) {

          const identifier = this.otpForm.getRawValue()['identifier']?.trim();
          const isEmail = identifier.includes('@');

          const redirectTo = resp?.redirect_to;
          console.log('redirect',redirectTo)
          
          localStorage.setItem('redirect_to',resp.redirect_to)

          const alreadyInUseMsg =
            redirectTo === 'email' ? 'Email is already registered. Please log in using the OTP sent to your inbox.' :
            redirectTo === 'mobile' ? 'Phone number is already registered. Please log in using the OTP sent via SMS.' :
            redirectTo === 'both' ? 'Account already exists. Please login via OTP sent to your inbox.' :
            'Account already exists. OTP sent successfully.';

          this.toast.success(alreadyInUseMsg);
          this.msg = alreadyInUseMsg;
          this.msgError = false;

          const loginPayload: any = { plan: 'lauditor' };

          if (redirectTo === 'both') {
            loginPayload.email = emailVal.toLowerCase();
            this.loginIdentifier = { type: 'email', value: emailVal.toLowerCase() };
            loginPayload.mobile = identifier;
            this.loginIdentifier = { type: 'mobile', value: identifier };
          }

          if (redirectTo === 'email') {
            loginPayload.email = emailVal.toLowerCase();
            this.loginIdentifier = { type: 'email', value: emailVal.toLowerCase() };
          } else if (redirectTo === 'mobile') {
            loginPayload.mobile = phoneVal;
            this.loginIdentifier = { type: 'mobile', value: phoneVal };
          } else if (isEmail) {
            loginPayload.email = identifier.toLowerCase();
            this.loginIdentifier = { type: 'email', value: identifier.toLowerCase() };
          } else {
            loginPayload.mobile = identifier;
            this.loginIdentifier = { type: 'mobile', value: identifier };
          }

          // Call login API to send OTP
          this.httpservice.sendPostRequest(URLUtils.login, loginPayload).subscribe(
            (loginResp: any) => {

              if (!loginResp.error) {
                this.otpSent = true; // Show OTP screen

                this.otpForm.get('identifier').disable();
                this.otpForm.get('fullname').disable();
                this.otpForm.get('email').disable();
                this.otpForm.get('phone').disable();

                this.otpSubmitted = false;

                // Enable OTP validation
                this.otpForm.get('otp').setValidators([
                  Validators.required,
                  Validators.pattern(/^[0-9]{6}$/)
                ]);

                this.otpForm.get('otp').updateValueAndValidity({ emitEvent: false });
                this.startResendTimer();
                // Keep this.msg as the already-set alreadyInUseMsg so the
                // mapped alert remains visible on the Verify OTP screen.
                this.msgError = false;
              } 
              else {
                this.msg = loginResp.msg;
                this.msgError = true;
              }
              this.otpRequestInProgress = false;
            },
            (error) => {
              this.otpRequestInProgress = false;
              this.msg = 'Error sending OTP. Please try again.';
              this.msgError = true;
              console.error(error);
            });

          return;
        }

        // Check if OTP was sent successfully
        if (resp.otp_sent || !resp['error']) {
          this.otpSent = true;
          this.msg = resp['msg'];
          this.msgError = resp['error'] === true; // Set based on resp.error
          
          this.otpForm.get('identifier').disable();
          this.otpForm.get('fullname').disable();
          this.otpForm.get('email').disable();
          this.otpForm.get('phone').disable();
          this.otpSubmitted = false;

          // Add OTP validation
          this.otpForm.get('otp').setValidators([
            Validators.required,
            Validators.pattern(/^[0-9]{6}$/)
          ]);
          this.otpForm.get('otp').updateValueAndValidity({ emitEvent: false });
          
          this.startResendTimer();
        } else {
          this.msg = resp['msg'];
          this.msgError = resp['error'] === true; // Set based on resp.error
        }
      },
      (error) => {
        this.otpRequestInProgress = false;
        this.msg = 'Error sending OTP. Please try again.';
        this.msgError = true;
        console.error('OTP request error:', error);
      }
    );
  }

  verifyOTPAndRegister() {
    this.otpRequestInProgress = true;
    console.log('verifyOTPAndRegister called, otpForm:', this.otpForm.value);

    const identifier = this.otpForm.get('identifier')?.value;
    const fullname = this.otpForm.get('fullname')?.value;
    const otp = this.otpForm.value['otp'];
    const isEmail = identifier.includes('@');

    const payload: any = {
      // fullname: fullname,
      // country: "India",
      // contact_person: fullname,
      // plan: "lauditor",
      // sub_model: "three_month_free",
      // is_active_sub: true,
      // sub_start_date: this.getCurrentDate(),
      // category: "solo",
      otp: otp  
    };

    // Add email or mobile
    if (this.loginIdentifier) {
      // Existing-account path (redirect_to from requestOTP): OTP was only
      // sent to the single channel indicated by redirect_to, so only that
      // channel should be sent back in the verify payload.
      if (this.loginIdentifier.type === 'email') {
        payload.email = this.loginIdentifier.value;
      } else {
        payload.mobile = this.loginIdentifier.value;
      }
      payload.plan = "lauditor";
    } else {
      // Fresh registration path: requestOTP() always sends the OTP to BOTH
      // the email and mobile provided (see requestOTP payload), so both
      // must be included here for verification to succeed.
      const emailVal = this.otpForm.get('email')?.value?.trim().toLowerCase();
      const phoneVal = this.otpForm.get('phone')?.value?.replace(/^0+/, '');

      if (emailVal) {
        payload.email = emailVal;
      }
      if (phoneVal) {
        payload.mobile = phoneVal;
      }
      // Fallback in the unlikely case both form values are empty but we
      // still have the identifier that was used to request the OTP.
      if (!emailVal && !phoneVal) {
        if (isEmail) {
          payload.email = identifier.toLowerCase();
        } else {
          payload.mobile = identifier;
        }
      }
      payload.plan = "lauditor";
    }
    // API call to verify OTP and complete registration
    if (this.otpSent) {

      this.httpservice.sendPostRequest(URLUtils.login, payload).subscribe(
        (resp: any) => {
          this.otpRequestInProgress = false;
          if (!resp['error']) {
            // Registration successful
            //this.msg = "Welcome! Your account is now verified";
            // Registration successful
            this.msg = this.loginIdentifier
              ? 'Login successful!'
              : 'Welcome! Your account is now verified';
            this.msgError = resp['error'] === true; // Set based on resp.error

            // Store user data
            if (resp['token']) {
              this.httpservice.setToken(resp['token']);
              localStorage.setItem('TOKEN', resp['token']);
            }

            if (resp['data']) {
              // Store user information
              if (resp['data']['id']) {
                localStorage.setItem('user_id', resp['data']['id']);
                this.syncDevice(resp['data']['id']);
              }
              if (resp['data']['name']) localStorage.setItem('name', resp['data']['name']);
              if (resp['data']['role']) localStorage.setItem('role', resp['data']['role']);
              if (resp['data']['admin']) localStorage.setItem('isadmin', resp['data']['admin']);
              if (resp['data']['uid']) localStorage.setItem('jid', resp['data']['uid']);
              if (resp['data']['requiresTermsAcceptance']) localStorage.setItem('requiresTermsAcceptance', JSON.stringify(resp['data']['requiresTermsAcceptance']));
              if (resp['data']['firm_name']) localStorage.setItem('firm_name', resp['data']['firm_name']);
              if (resp['data']['email']) localStorage.setItem('user_email', JSON.stringify(resp['data']['email']));
              if (resp['data']['plan']) localStorage.setItem('plan', resp['data']['plan'].toLowerCase());
              if (resp['data']['pk']) localStorage.setItem('prof_id', resp['data']['pk'].toLowerCase());
              if (resp['data']['profuid']) localStorage.setItem('profuid', resp['data']['profuid'].toLowerCase());
              if (resp['data']['category']) localStorage.setItem('category', resp['data']['category']);
              if (resp['data']['groups']) localStorage.setItem('user_groups', JSON.stringify(resp['data']['groups']));
              if (resp['data']['subscription']) {
                localStorage.setItem('isPaidSub', JSON.stringify(resp['data']['subscription']['is_active']));
              }
            }

            setTimeout(() => {
              this.router.navigate(['/grid']);
            }, 1500);
          } else {
            // Handle registration errors
            this.msg = resp['msg'];
            this.msgError = resp['error'] === true; // Set based on resp.error
          }
        },
        (error) => {
          this.otpRequestInProgress = false;
          this.msg = 'Error verifying OTP. Please try again.';
          this.msgError = true;
          console.error('Verification error:', error);
        }
      );
    }
    else {
      this.httpservice.sendOtpPostRequest(URLUtils.registerRequestOTP, payload).subscribe(
        (resp: any) => {
          this.otpRequestInProgress = false;
          if (!resp['error']) {
            // Registration successful
            this.msg = "Welcome! Your account is now verified";
            this.msgError = resp['error'] === true; // Set based on resp.error

            // Store user data
            if (resp['token']) {
              this.httpservice.setToken(resp['token']);
              localStorage.setItem('TOKEN', resp['token']);
            }

            if (resp['data']) {
              // Store user information
              if (resp['data']['id']) {
                localStorage.setItem('user_id', resp['data']['id']);
                this.syncDevice(resp['data']['id']);
              }
              if (resp['data']['name']) localStorage.setItem('name', resp['data']['name']);
              if (resp['data']['role']) localStorage.setItem('role', resp['data']['role']);
              if (resp['data']['admin']) localStorage.setItem('isadmin', resp['data']['admin']);
              if (resp['data']['uid']) localStorage.setItem('jid', resp['data']['uid']);
              if (resp['data']['category']) localStorage.setItem('category', resp['data']['category']);
              if (resp['data']['firm_name']) localStorage.setItem('firm_name', resp['data']['firm_name']);
              if (resp['data']['email']) localStorage.setItem('AAM_email', JSON.stringify(resp['data']['email']));
              if (resp['data']['plan']) localStorage.setItem('plan', resp['data']['plan'].toLowerCase());
              if (resp['data']['requiresTermsAcceptance']) localStorage.setItem('requiresTermsAcceptance', JSON.stringify(resp['data']['requiresTermsAcceptance']));
              if (resp['data']['groups']) localStorage.setItem('user_groups', JSON.stringify(resp['data']['groups']));
              if (resp['data']['subscription']) {
                localStorage.setItem('isPaidSub', JSON.stringify(resp['data']['subscription']['is_active']));
              }
            }

            setTimeout(() => {
              this.router.navigate(['/grid']);
            }, 1500);
          } else {
            // Handle registration errors
            this.msg = resp['msg'];
            this.msgError = resp['error'] === true; // Set based on resp.error
          }
        },
        (error) => {
          this.otpRequestInProgress = false;
          this.msg = 'Error verifying OTP. Please try again.';
          this.msgError = true;
          console.error('Verification error:', error);
        }
      );
    }
  }

  // -----------------------------------------------------------------------
  // Device sync — called after OTP verification succeeds and the session
  // is fully established (user_id is known from the login/verify response).
  //
  // Uses the same payload contract as the login flow so the backend can
  // associate this device with the new account immediately.
  //
  // Non-fatal: a sync failure never blocks the user from reaching /grid.
  // -----------------------------------------------------------------------
  syncDevice(userId: string): void {
    const payload: DeviceSyncLoginPayload = buildLoginDevicePayload(userId, this.product);

    this.httpservice.sendOtpPostRequest(URLUtils.deviceSync, payload).subscribe(
      (_resp: any) => {
        console.debug('[DeviceSync] register-verified sync OK', payload.device_id, 'user', userId);
      },
      (_error: any) => {
        console.debug('[DeviceSync] register-verified sync failed (non-fatal)');
      }
    );
  }

  // Resend OTP
  resendOTP() {
  if (this.resendDisabled) {
    return;
  }

  this.otpSubmitted = false;
  this.msg = '';
  this.msgError = false;

  // Reset OTP inputs
  this.otpForm.get('otp').reset();
  this.otpDigits = ['', '', '', '', '', ''];

  const payload: any = {
    plan: 'lauditor'
  };

  if (this.loginIdentifier) {
    // Existing-account path (redirect_to from requestOTP):
    // Resend OTP only through the channel originally selected.
    if (this.loginIdentifier.type === 'email') {
      payload.email = this.loginIdentifier.value;
    } else {
      payload.mobile = this.loginIdentifier.value;
    }
  } else {
    // Fresh registration path:
    // The initial OTP was sent to BOTH email and mobile.
    // Use getRawValue() because email and phone controls are disabled
    // after the OTP is initially sent.
    const formValues = this.otpForm.getRawValue();

    const emailVal = formValues.email?.trim().toLowerCase();
    const phoneVal = formValues.phone?.replace(/^0+/, '');

    // Always pass both email and mobile for a fresh registration.
    if (emailVal) {
      payload.email = emailVal;
    }

    if (phoneVal) {
      payload.mobile = phoneVal;
    }
  }

  this.otpRequestInProgress = true;

  this.httpservice.sendPostRequest(
    URLUtils.login,
    payload
  ).subscribe(
    (resp: any) => {
      this.otpRequestInProgress = false;

      if (!resp.error) {
        // Show custom message only for fresh registration
        // where OTP is resent to both email and mobile.
        if (!this.loginIdentifier) {
          this.msg = 'OTP resent successfully to your email and mobile';
        } else {
          // Keep existing API response message for existing-account flows.
          this.msg = resp.msg || 'OTP resent successfully';
        }

        this.msgError = false;
        this.startResendTimer();
      } else {
        this.msg = resp.msg;
        this.msgError = true;
      }
    },
    (error) => {
      this.otpRequestInProgress = false;
      this.msg = 'Error resending OTP. Please try again.';
      this.msgError = true;
      console.error('Resend OTP error:', error);
    }
  );
}


  // Start resend timer
  startResendTimer() {
    this.resendDisabled = true;
    this.resendTimer = 60;

    this.resendInterval = setInterval(() => {
      this.resendTimer--;
      if (this.resendTimer <= 0) {
        this.stopResendTimer();
      }
    }, 1000);
  }

  // Stop resend timer
  stopResendTimer() {
    if (this.resendInterval) {
      clearInterval(this.resendInterval);
      this.resendInterval = null;
    }
    this.resendDisabled = false;
    this.resendTimer = 60;
  }
}